import React from 'react';
import styled from 'styled-components';

import MoneyExchangeIconSvg from '../../assets/hotels/amenities/MoneyExchange.svg';

const MoneyExchangeIcon = styled(MoneyExchangeIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  height: 2rem;
  width: 2rem;
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default MoneyExchangeIcon;
